import { render, staticRenderFns } from "./fidelior-fees.vue?vue&type=template&id=379be8ce&"
import script from "./fidelior-fees.vue?vue&type=script&lang=js&"
export * from "./fidelior-fees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports